import { Store, applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { ApplicationState, storeReducer } from "./app/store";

export default function configureStore(initialState: ApplicationState): Store<ApplicationState> {
	const middlewares = [thunk];
	return createStore(storeReducer, initialState, applyMiddleware(...middlewares));
}
